import { render, staticRenderFns } from "./SettingsMrDocuments.vue?vue&type=template&id=73136fce"
import script from "./SettingsMrDocuments.vue?vue&type=script&lang=js"
export * from "./SettingsMrDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports